/**
 * The `recordingId` a picker's recommendation query may be keyed on.
 *
 * A draft-editor host anchors suggestions on a draft NODE, which is not a
 * recording. The endpoint uses this value for nothing but excluding the current
 * recording from its aggregate, so handing it a node id would fragment the cache
 * per node for no gain. The node id still reaches the suggestion-source props
 * (`requestContext` / `sourceRecordingId`), which is where it belongs.
 */
export function recommendationRecordingId(
  recordingId: string | undefined,
  draftProcessId: string | undefined
): string | undefined {
  return draftProcessId ? undefined : recordingId;
}
